export default { options: { label: 'Matchevent Types' } }
